module.exports = __webpack_public_path__ + "static/media/Edit2_istockphoto-1093092328-170667a.288ac662.jpg";